const myTransactions = {
  selectDateRage:'Виберіть діапазон дат',
  selectTransactionType:'Виберіть тип транзакції',
  selectApplication:'Виберіть програму',
  export:'Експорт',
  myTransactions:'Мої транзакції',
  showing:'Показано',
  transactionsOf:'транзакції з',
  noTransactionsFound:'Транзакцій не знайдено',
};

export default myTransactions;
